import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { SubServicesField } from '../../subservicesfields/subservicesfield.model';
import { MainService } from '../../mainservices/mainservices.model';
import { SubServices } from '../../subservices/subservices.model';
import { MainserviceService } from '../../mainservices/mainservice.service';
import { SubservicesService } from '../../subservices/subservices.service';
import { SubservicesfieldsService } from '../../subservicesfields/subservicesfields.service';
import { SubservicesfieldsdropdownitemsserviceService } from '../subservicesfieldsdropdownitemsservice.service';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FieldsDropDownItems } from '../fieldsdropdownitems.model';

@Component({
  selector: 'app-subservicesfieldsdropdownitemsform',
  templateUrl: './subservicesfieldsdropdownitemsform.component.html',
  styleUrls: ['./subservicesfieldsdropdownitemsform.component.css']
})
export class SubservicesfieldsdropdownitemsformComponent implements OnInit {

  subServiceFieldsDropDownItemsForm!: FormGroup

  mainServiceList: MainService[] = [];
  subServicesList: SubServices[] = [];
  subServicesFieldsList: SubServicesField[] = [];
  subServicesFieldsDropDownItemsList: FieldsDropDownItems[] = [];
  mainServicestatusList: { id: boolean, name: string }[] = [];
  spinnerOverlay = false;
  constructor(
    private mainService: MainserviceService,
    private subServiceService: SubservicesService,
    private subServiceFieldsService: SubservicesfieldsService,
    private service: SubservicesfieldsdropdownitemsserviceService,
    private translateService: TranslateService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.connectFormGroup()

    this.mainServicestatusList = [{ id: true, name: this.translateService.instant("active") },
    { id: false, name: this.translateService.instant("notActive") }];

    this.getMainService();
  }

  connectFormGroup() {

    let _subServiceFieldsDropDownItems = new FormArray([]);

    this.subServiceFieldsDropDownItemsForm = new FormGroup({

      id: new FormControl(null),
      mainServiceId: new FormControl(null, [
        Validators.required
      ]),
      mainServiceStatus: new FormControl(true),
      subServiceId: new FormControl(null, [
        Validators.required
      ]),
      subServiceFieldId: new FormControl(null, [
        Validators.required
      ]),
      subServiceFieldsDropDownItems: _subServiceFieldsDropDownItems!,
    });

    this.addSubServiceFieldsDropDownItemsRow();
    // this.getUserCategory();
  }

  getSubServiceFieldsDropDownItemsControls() {
    return (<FormArray>this.subServiceFieldsDropDownItemsForm.get('subServiceFieldsDropDownItems')).controls;
  }

  addSubServiceFieldsDropDownItemsRow() {
    (<FormArray>this.subServiceFieldsDropDownItemsForm.get('subServiceFieldsDropDownItems')).push(
      new FormGroup({
        id: new FormControl(""),
        arabicName: new FormControl(''),
        englishName: new FormControl(''),
      }))
  }

  deleteRow(index: number) {

    const control = (<FormArray>this.subServiceFieldsDropDownItemsForm.get('subServiceFieldsDropDownItems'));
    if (control.length != 1)
      control.removeAt(index);

  }

  selectMainServiceStatusChange() {
    this.getMainService();
  }

  getMainService() {
    this.mainService.getAll(this.subServiceFieldsDropDownItemsForm.value.mainServiceStatus).subscribe(data => {
      this.mainServiceList = data

    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  getSubService() {
    this.spinnerOverlay = true;
    this.subServiceService.getAll(this.subServiceFieldsDropDownItemsForm.value.mainServiceId, true).subscribe(data => {
      this.subServicesList = data;
      this.spinnerOverlay = false;
    })
  }

  getSubServiceFields() {
    this.spinnerOverlay = true;
    this.subServiceFieldsService.getAll(this.subServiceFieldsDropDownItemsForm.value.subServiceId).subscribe(data => {
      this.subServicesFieldsList = data.filter(x => x.type == 2);
      this.spinnerOverlay = false;
    })
  }

  onSelectMainService() {
    this.getSubService()
  }

  onSelectSubServices() {
    this.getSubServiceFields();
  }

  onSelectSubServiceFields() {
    this.get();
  }

  get() {
    this.spinnerOverlay = true;
    this.subServicesFieldsDropDownItemsList = [];
    const arrayControl = this.subServiceFieldsDropDownItemsForm.get('subServiceFieldsDropDownItems') as FormArray;
    arrayControl.clear();
    this.addSubServiceFieldsDropDownItemsRow();

    this.service.getAll(this.subServiceFieldsDropDownItemsForm.value.subServiceFieldId).subscribe(data => {
      this.subServicesFieldsDropDownItemsList = data;
      this.fillControl();
      this.spinnerOverlay = false
    }, error => {
      console.log(error)
      this.spinnerOverlay = false;
    })
  }


  fillControl() {

    if (this.subServicesFieldsDropDownItemsList.length > 0) {
      (<FormArray>this.subServiceFieldsDropDownItemsForm.get('subServiceFieldsDropDownItems')).removeAt(0);
    }
    for (let i = 0; i < this.subServicesFieldsDropDownItemsList.length; i++) {

      (<FormArray>this.subServiceFieldsDropDownItemsForm.get('subServiceFieldsDropDownItems')).push(
        new FormGroup({
          id: new FormControl(this.subServicesFieldsDropDownItemsList[i].id),
          arabicName: new FormControl(this.subServicesFieldsDropDownItemsList[i].arabicName),
          englishName: new FormControl(this.subServicesFieldsDropDownItemsList[i].englishName),
        }));
    }

  }

  submit() {
    this.create();
  }

  create() {
    this.spinnerOverlay = true;
    var subServiceFieldsDropDownItems = this.subServiceFieldsDropDownItemsForm.value.subServiceFieldsDropDownItems;
    var listSubServiceFieldsDropDownItems = [];

    for (let i = 0; i < subServiceFieldsDropDownItems.length; i++) {
      var obj = {
        id: subServiceFieldsDropDownItems[i].id != "" && subServiceFieldsDropDownItems[i].id != null ?
          subServiceFieldsDropDownItems[i].id : 0,
        arabicName: subServiceFieldsDropDownItems[i].arabicName,
        englishName: subServiceFieldsDropDownItems[i].englishName,
        subServiceFieldId: this.subServiceFieldsDropDownItemsForm.value.subServiceFieldId
      }
      listSubServiceFieldsDropDownItems.push(obj)

    }
    console.log("listSubServiceFieldsDropDownItems")
    console.log(listSubServiceFieldsDropDownItems)

    this.service.CreateUpdate(listSubServiceFieldsDropDownItems).subscribe(data => {
      this.openSnackBar(this.translateService.instant("createdSuccessfully"), 'snackBarSuccess');
      // this.get();
      this.spinnerOverlay = false
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

        this.spinnerOverlay = false;
      })
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }


}
